import moment from "moment";
import { message } from "antd";
import types from "../types";
import base64 from "base-64";
import { createAction } from "redux-actions";
import { push } from "../../router/history";
import { showFailSnackbar } from "../../common/actions/snackbar";

export const setToken = createAction(types.SET_TOKEN);
export const setLoading = createAction(types.SET_LOADING);
export const setUser = createAction(types.SET_USER);

const handleAuthResponse = ({ payload }) => {
  localStorage.setItem("@jarvis/token", base64.encode(payload.data.token));
  localStorage.setItem("@minerva/last-login", moment().format());
  localStorage.setItem("@jarvis/user", JSON.stringify(payload.data.user));
  return payload;
};

export function makeLogin(values) {
  return async (dispatch, getState) => {
    let value = {};
    values.email.trim();
    values.password.trim();

    value = {
      email: values.email,
      password: values.password,
    };

    return dispatch({
      type: types.AUTH,
      payload: {
        request: {
          url: "login",
          method: "POST",
          data: value,
        },
      },
    })
      .then(async ({ payload }) => {
        const { user, token } = payload.data;
        localStorage.setItem(
          "@jarvis/token",
          base64.encode(payload.data.token)
        );
        localStorage.setItem("@jarvis/last-login", moment().format());
        localStorage.setItem("@jarvis/user", JSON.stringify(payload.data.user));

        push("/dashboard");
      })
      .catch((error) => {
        if (error && error.response) {
          switch (error.response.status) {
            case 401:
              return dispatch(showFailSnackbar("Email ou senha incorretas"));
            default:
              return dispatch(
                showFailSnackbar(
                  "Ocorreu um problema com o pedido de autenticação. Tente novamente, mais tarde."
                )
              );
          }
        }

        /*return dispatch(
          showFailSnackbar(
            "Verifique seu email e senha ou tente novamente mais tarde."
          )
        );*/
      });
  };
}

export const auth = (values) => (dispatch, getState) => {
  let value = {};
  value = {
    email: values.email,
    password: values.password,
  };
  dispatch({
    type: types.AUTH,
    payload: {
      request: {
        url: "login",
        method: "POST",
        value,
      },
    },
  })
    .then(handleAuthResponse)
    .then(() => {
      const { location } = getState().get("route").toJS();
      if (location.state && location.state.from) {
        return dispatch(push(location.state.from.pathname));
      }

      return dispatch(push("/"));
    })
    .catch(({ error }) => {
      if (error && error.response) {
        switch (error.response.status) {
          case 401:
            return message.error(
              "Email or password not valid. Please fix your credentials."
            );
          default:
            return message.error(
              "Ocorreu um problema com o pedido de autenticação. Tente novamente, mais tarde."
            );
        }
      }

      return message.error(
        "Ocorreu um problema com o pedido de autenticação. Tente novamente, mais tarde."
      );
    });
};

export const renew = () => (dispatch) =>
  dispatch({
    type: types.RENEW,
    payload: {
      request: {
        url: "/renew",
        method: "POST",
      },
    },
  })
    .then(handleAuthResponse)
    .catch(() => {
      localStorage.removeItem("@jarvis/token");
      localStorage.removeItem("@jarvis/user");
      dispatch(push("/"));
    });

export const verifyLogin = () => (dispatch, getState) => {
  dispatch(setLoading(true));
  const { auth } = getState().get("login").toJS();

  const token = localStorage.getItem("@jarvis/token");
  const user = localStorage.getItem("@jarvis/user");

  if (token && user) {
    if (!auth.token) {
      dispatch(setToken(base64.decode(token)));
    }

    if (!auth.user) {
      dispatch(setUser(JSON.parse(user)));
    }

    const lastLogin = moment(localStorage.getItem("@jarvis/last-login"));
    if (moment().diff(lastLogin, "days") <= 1) {
      dispatch(renew());
    }

    setLoading(false);
    push("dashboard");
    return true;
  }

  localStorage.removeItem("@jarvis/token");
  localStorage.removeItem("@jarvis/user");

  dispatch(setLoading(false));
  return false;
};

export const logout = () => (dispatch) => {
  localStorage.removeItem("@jarvis/token");
  localStorage.removeItem("@jarvis/user");
  dispatch(setToken(null));
  dispatch(setUser(null));
  dispatch(setLoading(false));
  push("/");
};
